(function () {
  angular.module("akitabox.workOrder.create", [
    "ui.router",
    "akitabox.constants",
    "akitabox.core.constants",
    "akitabox.core.router",
    "akitabox.core.toast",
    "akitabox.core.services.building",
    "akitabox.core.services.flag",
    "akitabox.core.services.user",
    "akitabox.core.services.issueType",
    "akitabox.core.services.pinValue",
    "akitabox.core.services.timeZone",
    "akitabox.core.services.trade",
    "akitabox.core.services.type",
    "akitabox.core.services.user",
    "akitabox.core.services.workOrder",
    "akitabox.core.constants",
    "akitabox.ui.components.multipleAssigneeInput",
  ]);
})();
